export const environments = [
  {
    value: 'dev',
    label: 'DEV',
    endpoints: {
      auth: 'https://func-ymtapi-transx-dev-westus2-001.azurewebsites.net/api/token',
      api: 'https://func-ymtapi-transx-dev-westus2-001.azurewebsites.net/api',
    },
  },
  {
    value: 'preprod',
    label: 'PREPROD',
    endpoints: {
      auth: 'https://func-ymtapi-transx-preprod-westus2-001.azurewebsites.net/api/token',
      api: 'https://func-ymtapi-transx-preprod-westus2-001.azurewebsites.net/api',
    },
  },
  {
    value: 'prod',
    label: 'PRODUCTION',
    endpoints: {
      auth: 'https://func-ymtapi-transx-prod-westus2-001.azurewebsites.net/api/token',
      api: 'https://func-ymtapi-transx-prod-westus2-001.azurewebsites.net/api',
    },
  },
];

export const tenant = {
  name: 'TransX', // do not change without checking references for environment.tenant.name. Some conditional logic exists per-client.
  isNameShownOnLoginScreen: false,
  productName: 'Asset Cloud',
  id: '001',
  logo: {
    url: 'assets/tenants/transx/img/logo.png',
    width: '18rem',
  },
  additionalLogo: null,
};
